module.exports = __webpack_public_path__ + "img/customer-3-300x300.f77c579f.png";